import React from "react";

import EnquiryForm1 from "src/modules/EnquiryForms/EnquiryForm1";

type Props = {};

const NewEnquiryForm = (props: Props) => {
  // useEffect(() => {
  //     if (currentUser?.role != USER_ROLES.OFF_TAKER) {
  //         navigate(-1)
  //     }
  //     return () => { }
  // }, [])

  return (
    <div className="flex flex-col space-y-2 p-2 mb-20">
      <div className="text-xl text-primary uppercase font-semibold">Enquiry Request</div>
      <EnquiryForm1 />
    </div>
  );
};

export default NewEnquiryForm;
